<div>
	<google-map
		class="google-map-container"
		[center]="guardianHouseholdLatLng"
		[zoom]="8"
		[options]="mapOptions"
		#mapComp="googleMap"
		[height]="640"
 		[width]="650">
	</google-map>
</div>
